<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="orderObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
      <v-container fluid slot="filterForm" class="pt-0">
        <v-row>
          <v-col cols="12" sm="2" lg="5">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="primary"  dark v-on="on">{{$t('message.common.add')}}</v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="6" sm="1" lg="1">
            <v-btn fab dark @click="exportOrders" small color="success" :loading="exportLoading">
              <v-icon dark id="generateexcel">mdi-file-excel</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" sm="3" lg="2">
            <v-select v-model="filterObj.type" dense outlined clearable :items="$_orderType" item-text="text" item-value="value" :label="$t('message.whOrder.orderType')" hide-details></v-select>
          </v-col>
          <v-col cols="6" sm="3" lg="2">
            <v-select v-model="filterObj.status" dense outlined clearable :items="statusList" item-text="text" item-value="value" :label="$t('message.customer.status')" hide-details></v-select>
          </v-col>
          <v-col cols="6" sm="3" lg="2">
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getOrderListHandler" @click:append="getOrderListHandler" single-line outlined dense v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </data-list>
    <v-dialog v-model="downloadObj.dialog" persistent max-width="500px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.order.download') }} {{ $t('message.warehouse.order') }} {{ downloadObj.model ? downloadObj.model.number : '' }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="6">
              <v-checkbox dense hide-details v-model="downloadObj.withLocs" :label="$t('message.whOrder.withLocations')"></v-checkbox>
            </v-col>
            <v-col cols="6">
              <v-checkbox dense hide-details v-model="downloadObj.withPrices" :label="$t('message.whOrder.withPrices')"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="downloadObj.onSuccess">{{ $t('message.order.download') }}</v-btn>
          <v-btn color="error" @click="downloadObj.onClose">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div id="noso_products" style="visibility: hidden;"></div>
  </div>
</template>
<script>
import DataList from '@/components/DataList'
import { mapState } from 'vuex'
import CONSTANTS from '@/utils/warehouse.json'
export default {
  components: {
    DataList
  },
  data () {
    return {
      filterObj: {
        'descending': true,
        'totalitems': 0,
        'status': null,
        'type': null
      },
      downloadObj: {
        dialog: false,
        onSuccess: () => false,
        onClose: () => false
      },
      search: '',
      filterBy: 'supplier',
      exportLoading: false,
      orderObj: {
        isHeader: true,
        isHideAdd: true,
        hasFilters: true,
        selection: [],
        isWarehouseOrder: true,
        showSelect: false,
        isStock: true,
        list: [],
        page: 1,
        loading: false,
        editProp: 'number',
        editURL: (item) => this.navigateToOrder(item),
        actionsList: [{
          click: (item) => this.openDownloadHandler(item), // this.$parent.$parent.printOrder,
          icon: () => 'mdi-arrow-down-bold-circle-outline',
          is_show: () => true
        }, {
          click: this.$parent.$parent.sendReport,
          icon: () => 'mdi-email-variant',
          is_show: () => true
        }, {
          click: this.$parent.$parent.donwloadPrintedProducts,
          icon: () => 'mdi-printer',
          is_show: (item) => item.type_ref === CONSTANTS.SUPPLIER
        }, {
          click: this.deleteOrder,
          icon: () => 'mdi-trash-can-outline',
          is_show: (item) => item.status_ref === CONSTANTS.DRAFT
        }]
      },
      total: 0,
      page: 1,
      loading: false,
      MODULE_URL: 'warehouseorders',
      orderModel: {},
      isValidEmail: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.WH_ORDER_INDEX) ? this.$store.state.WH_ORDER_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [true], search: '', page: 1 }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = {
          type: 'WH_ORDER_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getOrderListHandler()
      },
      deep: true
    },
    search: function (newValue, oldValue) {
      let filterObj = this.$formatter.cloneVariable(this.filterObj)
      filterObj.search = newValue
      let data = { type: 'F_WH_ORDERS', data: { filter: filterObj } }
      this.$store.commit('rememberFilter', data)
      if (!newValue) this.getOrderListHandler()
    },
    filterObj: {
      handler (newValue, oldValue) {
        if (newValue) {
          let data = { type: 'F_WH_ORDERS', data: { filter: newValue } }
          this.$store.commit('rememberFilter', data)
          this.getOrderListHandler()
        }
      },
      deep: true
    }
  },
  computed: {
    statusList () {
      return [ { text: this.$t('message.common.draft'), value: 'draft' },
        { text: this.$t('message.common.ready'), value: 'ready' },
        { text: this.$t('message.common.request'), value: 'request' },
        { text: this.$t('message.common.inProgress'), value: 'inprogress' },
        { text: this.$t('message.common.ordered'), value: 'ordered' },
        { text: this.$t('message.common.picked'), value: 'picked' },
        { text: this.$t('message.common.partiallyPicked'), value: 'partiallypicked' },
        { text: this.$t('message.common.partiallyReceived'), value: 'partiallyreceived' },
        { text: this.$t('message.common.received'), value: 'received' } ]
    },
    menuItems () {
      return [{ title: 'message.whOrder.supplierOrder', to: '/w_h/order/supplierorder/actions' },
        { title: 'message.warehouse.lowStockProposal', to: '/w_h/order/lowstockproposal' },
        { title: 'message.whOrder.adjustmentOrder', to: '/w_h/order/adjustmentorder/actions' },
        { title: 'message.whOrder.returnOrder', to: '/w_h/order/returnorder/actions' },
        { title: 'message.whOrder.transferOrder', to: '/w_h/order/transferorder/actions' }]
    },
    ...mapState(['WH_ORDER_INDEX', 'listOfLocations', 'listOfWarehouse']),
    headers () {
      return [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '80px'
      }, {
        text: this.$t('message.whOrder.orderType'),
        value: 'type',
        width: '10%'
      }, {
        text: this.$t('message.orders.salesReference'),
        value: 'salesreference',
        width: '10%'
      }, {
        text: this.$t('message.whOrder.from'),
        value: 'supplier_name',
        width: '13%'
      }, {
        text: this.$t('message.whOrder.to'),
        value: 'warehouse_name',
        width: '9%'
      }, {
        text: this.$t('message.whOrder.orderDate'),
        value: 'orderdate',
        width: '6%'
      }, {
        text: this.$t('message.whOrder.requested'),
        value: 'estimated_date',
        width: '6%'
      }, {
        text: this.$t('message.whOrder.confirmed'),
        value: 'confirmed_date',
        width: '6%'
      }, {
        text: this.$t('message.order.salesOrder'),
        value: 'salesordernumber',
        width: '6%'
      }, {
        text: this.$t('message.customer.status'),
        value: 'status',
        width: '7%'
      }, {
        text: this.$t('message.whOrder.ourContact'),
        value: 'responsible',
        width: '12%'
      }, {
        text: '',
        value: 'actions',
        width: '10%'
      }]
    }
  },
  created () {
    this.$store.dispatch('getWarehouse')
    this.$store.dispatch('getWarehouseLocations')
  },
  mounted () {
    document.title = `Lager/Bestillinger`
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.orderObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getOrderListHandler()
      }
    })
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WH_ORDERS)) {
      let order = this.$formatter.cloneVariable(this.$store.state.F_WH_ORDERS)
      this.filterObj = order.filter
      this.search = this.filterObj.search
    }
    this.$root.$on('listLoading', (data) => {
      this.orderObj.loading = data
    })
  },
  methods: {
    getOrderListHandler () {
      this.orderObj.loading = true
      this.filterObj.rowsperpage = this.pagination.itemsPerPage
      this.filterObj.descending = this.pagination.sortDesc[0]
      this.filterObj.sortby = this.pagination.sortBy[0]
      this.filterObj.page = this.pagination.page
      this.filterObj.search = this.search
      const getIds = this.$route.query.ids || null
      if (getIds) this.filterObj.ids = getIds ? JSON.parse(getIds) : []
      this.orderObj.module = this.MODULE_URL
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, this.filterObj).then(response => {
        let orderList = response.data.items
        let transformList = { date: { list: ['orderdate', 'estimated_date', 'confirmed_date'], from: 'DD.MM.YYYYTH:mm:ss', to: 'DD.MM.YYYY' },
          status: [{ list: ['type'], value: '$_orderType' }, { list: ['status'], value: '$_orderStatus' }, { list: ['priority'], value: '$_priorityList' }] }
        let model = this.$_formatListModel(orderList, transformList)
        let result = []
        model.forEach(element => {
          element.type_ref = element.type.value
          element.type = element.type.text
          element.status_ref = element.status.value
          element.status = element.status.text
          element.priority = element.priority.text
          result.push(element)
        })
        this.total = response.data.total
        if (this.filterObj.page > 1 && this.total <= this.filterObj.rowsperpage * (this.filterObj.page - 1)) {
          this.pagination.page = 1
          this.orderObj.page = 1
        }
        this.orderObj.list = result
      }).finally(() => {
        this.orderObj.loading = false
      })
    },
    openDownloadHandler (item) {
      if (item.type_ref === 'supplier') {
        this.downloadObj = {
          dialog: true,
          model: item,
          withPrices: false,
          withLocs: false,
          onSuccess: () => {
            this.$parent.$parent.printOrder(item, this.downloadObj)
            this.downloadObj.dialog = false
          },
          onClose: () => {
            this.downloadObj.dialog = false
          }
        }
      } else {
        this.$parent.$parent.printOrder(item)
      }
    },
    exportOrders () {
      this.exportLoading = true
      const getIds = this.$route.query.ids || null
      if (getIds) this.filterObj.ids = getIds ? JSON.parse(getIds) : []
      this.$_executeApi('post', 'warehouseorders/export_orders', this.filterObj)
        .then((response) => {
          this.$_downloadExportedReport(response.data).then(() => { this.exportLoading = false })
        })
    },
    navigateToOrder (item) {
      if (item.type_ref === CONSTANTS.SUPPLIER) return `/w_h/order/supplierorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.ADJUSTMENT) return `/w_h/order/adjustmentorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.RETURN) return `/w_h/order/returnorder/actions/${item.id}`
      else if (item.type_ref === CONSTANTS.TRANSFER) return `/w_h/order/transferorder/actions/${item.id}`
    },
    deleteOrder (item) {
      let payload = { ids: [item.id], url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$root.$on('listLoading')
  }
}
</script>
